var BlockView = require('views/block/base-block-view');

var CanvasView = BlockView.extend({
  play: function() {
    this.readyToGo();
  }
});

module.exports = CanvasView;